module.exports = __webpack_public_path__ + "img/adpoints-logo.40eac4c6.png";